import React from 'react'
import LectureList from './LectureList'

const ScheduleList = (props) => {
    
   return <LectureList history={props.history}/>
}

export default ScheduleList